import StartUp from './start-up';

export default StartUp;